import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  ViewChild,
  ChangeDetectionStrategy,
  inject,
  output,
  input,
} from '@angular/core';
import { ControlContainer, FormsModule, NgForm, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { Observable, ReplaySubject } from 'rxjs';
import { uniqueId } from '@shared/utils';

@Component({
  selector: 'ui-form',
  templateUrl: './form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormComponent {
  controlContainer = inject(ControlContainer);
  private _cdRef = inject(ChangeDetectorRef);

  readonly idAttribute = input<string>(uniqueId());

  readonly handleSubmit = output<void>();

  @ViewChild('formDirectiveRef', { static: true })
  formDirectiveRef: NgForm | null = null;

  @HostBinding('class.is-submitted')
  get submittedClass() {
    return this.formDirectiveRef && this.formDirectiveRef.submitted;
  }

  submitted = false;
  submitted$ = new ReplaySubject<boolean>(1);

  constructor() {
    this.setSubmitted(false);
  }

  getSubmitted(): Observable<boolean> {
    return this.submitted$.asObservable();
  }

  triggerSubmit() {
    this.setSubmitted(true);
    this.handleSubmit.emit();
  }

  resetSubmitted() {
    this.setSubmitted(false);
    // signal query rodiče vrací formulář už v jeho ngOnInit, kdy FormGroupDirective ještě nemá [formGroup]
    if (this.formDirectiveRef?.form) this.formDirectiveRef.resetForm();
    this._cdRef.markForCheck();
  }

  setSubmitted(submitted: boolean) {
    this.submitted = submitted;
    this.submitted$.next(submitted);
  }

  get controls() {
    return this.controlContainer.control as UntypedFormGroup;
  }
}
